import React from 'react';

import { style } from 'typestyle';

export function NotFound() {
  return (
    <div className={notFoundClass}>
      <h1>
        {window.T('common.notfound')}
      </h1>
    </div>
  );
}

const notFoundClass = style({
  position: 'fixed',
  height: '100%',
  width: '100%',
  top: 0,
  left: 0,
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  flexDirection: 'column',
  backgroundColor: '#212121',
  fontFamily: 'Public Sans, sans-serif',
  zIndex: 1,
});
